import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getHandovers: function ({limit = 50, page = 1, approved, client, handoverDefinition, handoverCounter,
    user, date, own, tag }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, 'sort[]=date&sort[]=-1']
    if (own && own !== ' ') query.push(own)
    if (tag && tag !== ' ') query.push(tag)
    if (handoverCounter) query.push(`handoverCounter[]=${handoverCounter}`)
    if (approved) query.push(`approved[]=${approved}`)
    if (client) query.push(`client[]=${client}`)
    if (handoverDefinition) query.push(`handoverDefinition[]=${handoverDefinition}`)
    if (user) query.push(`user=${user}`)
    if (date) query.push(`date[]=${date}`)
    return instCred.get('handovers?' + query.join('&'))
  },
  getHandoverById: function (handoverId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('handovers/' + handoverId)
  },
  getHandoverCounter: function (clientId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('handovers/counter/' + clientId)
  },
  createHandover: function (handover) {
    handover.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('handovers', handover)
  },
  updateHandover: function (handover) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('handovers/' + handover.id, handover)
  },
  deleteHandover: function (handoverId) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.delete('handovers/' + handoverId)
  }
}



// WEBPACK FOOTER //
// ./src/api/ContactHandover/api.js